<template>
  <!-- <g-pdf v-if="pdfAparecer"  :pdfFloat="false" :NovaGuia="true"> -->
  <div class="card-pdf-pedido-final">
    <g-card class="card-principal" :temCabecalho="false" :expansivel="false" margem="0" paddingDefault="0">
      <div class="informacoes-pdf-pedido-final">
        <div class="container-principal-gerador-paginas">
          <div class="content-grupo informacoes-pedido">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo"></div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <img src="@/assets/imgs/Rodape_Orcamento_inicio.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-pedido grupo">
              <div class="container">
                <div class="grupo-pedido conteudo-grupo">
                  <div class="unidade-representante">
                    <div class="titulo-conteudo-cabecalho"> Representante: &nbsp; <div class="label-cabecalho">{{detalhesDoPedidoFluxo.NomeRepresentante}}</div></div>
                    <div class="titulo-conteudo-cabecalho"> Unidade: &nbsp; <div class="label-cabecalho">{{detalhesDoPedidoFluxo.NomeEmpresa}}</div></div>
                  </div>

                  <div class="detalhes-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-detalhes-pedido">
                      <div class="titulo-grupo"> DETALHES DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-detalhes-pedido">
                      <div class="pedido">
                        <div class="titulo-conteudo-detalhes"> Pedido </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.CodigoExternoPedido}}</div>
                      </div>

                      <div class="orcamento">
                        <div class="titulo-conteudo-detalhes"> Orçamento </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.CodigoExternoOrcamento}}</div>
                      </div>

                      <div class="cliente-cnpj">
                        <div class="titulo-conteudo-detalhes"> Cliente/CNPJ </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.NomeFantasia}} - {{detalhesDoPedidoFluxo.CnpjFormatado}}</div>
                      </div>

                      <div class="cv">
                        <div class="titulo-conteudo-detalhes"> CV </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.CurvaClienteTexto}}</div>
                      </div>

                      <div class="unidade">
                        <div class="titulo-conteudo-detalhes"> Unidade </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.NomeEmpresa}}</div>
                      </div>

                      <div class="representante">
                        <div class="titulo-conteudo-detalhes"> Representante </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.NomeRepresentante}}</div>
                      </div>

                      <div class="tipo">
                        <div class="titulo-conteudo-detalhes"> Tipo </div>
                        <div class="label-conteudo">{{detalhesDoPedidoFluxo.TipoPedidoTexto}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="dados-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-dados-pedido">
                      <div class="titulo-grupo"> DADOS DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-dados-pedido">
                      <div class="status">
                        <div class="titulo-conteudo-detalhes"> Status </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.StatusPedidoTexto}}</div>
                      </div>

                      <div class="programacao-kanban">
                        <div class="titulo-conteudo-detalhes"> Programação Kanban </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.ProgramacaoKanban == false ? 'Não' : 'Sim' }}</div>
                      </div>

                      <!-- <div class="comissao-repr">
                        <div class="titulo-conteudo-detalhes"> Comissão Repr. </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.PorcentagemComissaoRepresentante}}%</div>
                      </div> -->

                      <div class="preco">
                        <div class="titulo-conteudo-detalhes"> Preço </div>
                        <div class="label-conteudo"> {{formataMonetario(novoPedidoDetalhes.ValorPrecoFinal)}}</div>
                      </div>

                      <div class="transportadora">
                        <div class="titulo-conteudo-detalhes"> Transportadora </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.NomeTransportadora || '-'}}</div>
                      </div>

                      <div class="digitacao">
                        <div class="titulo-conteudo-detalhes"> Digitação </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.DataDigitacaoFormatada}}</div>
                      </div>

                      <div class="codigo-acesso" v-if="novoPedidoDetalhes.CodigoAcesso"> 
                        <div class="titulo-conteudo-detalhes"> Código de Acesso </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.CodigoAcesso}}</div>
                      </div>

                      <div class="exportacao" v-if="novoPedidoDetalhes.Exportacao">
                        <div class="titulo-conteudo-detalhes"> Exportação </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.Exportacao == false ? 'Não' : 'Sim'}}</div>
                      </div>

                      <div class="precoTot-sem-ipi">
                        <div class="titulo-conteudo-detalhes"> Preço Total Sem IPI </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.PrecoTotalSemIPIFormatado}}</div>
                      </div>

                      <div class="papel-seda">
                        <div class="titulo-conteudo-detalhes"> Papel Seda </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.EnviarPapelSedaDescricao}}</div>
                      </div>

                      <div class="frete-cidade">
                        <div class="titulo-conteudo-detalhes"> Frete/Cidade </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.IndicadorDeTipoFreteEnum}} / {{novoPedidoDetalhes.NomeCidade }}</div>
                      </div>

                      <div class="comissao-venda">
                        <div class="titulo-conteudo-detalhes"> Comissão Venda </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.PorcentagemComissaoVenda}}%</div>
                      </div>

                      <div class="condicao-pagto">
                        <div class="titulo-conteudo-detalhes"> Condição Pagamento </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.CondicaoPagamento}}</div>
                      </div>

                      <div class="qtd-total">
                        <div class="titulo-conteudo-detalhes"> Qtd. Total </div>
                        <div class="label-conteudo">{{formataDecimal(novoPedidoDetalhes.NumeroQuantidadeTotalFormatado)}}</div>
                      </div>                    
                    </div>
                  </div>

                  <div class="caracteristicas-pedido conteudo">
                    <div class="borda-titulo-grupo titulo-caracts-pedido">
                      <div class="titulo-grupo"> CARACTERÍSTICAS DO PEDIDO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-caracts-pedido">
                      <div class="impressao">
                        <div class="titulo-conteudo-detalhes"> Impressão </div>
                        
                        <div v-if="!(caracteristicasPedido.ImpressaoAmostra &&
                          caracteristicasPedido.ImpressaoProvaDeCores &&
                          caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar &&
                          caracteristicasPedido.ImpressaoNumeroPantone &&
                          caracteristicasPedido.ImpressaoNumeroDoProduto &&
                          caracteristicasPedido.ImpressaoOutros)"
                        >                                                                            
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoAmostra == true ? 'Amostra' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCores == true ? 'Prova De Cores' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar == true ? 'Prova De Cores a Confeccionar' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroPantone ? `Pantone Nº ${caracteristicasPedido.ImpressaoNumeroPantone}` : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroDoProduto ? `Produto: ${caracteristicasPedido.ImpressaoNumeroDoProduto}` : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoOutros ? `Outros: ${caracteristicasPedido.ImpressaoOutros}` : ''}} </div>
                        </div>

                        <div class="label-conteudo" v-else> Sem dados </div>
                      </div>

                      <div class="visual">
                        <div class="titulo-conteudo-detalhes"> Visual </div>

                        <div v-if="!(caracteristicasPedido.VisualAmostra &&
                          caracteristicasPedido.VisualArquivoDescricao &&
                          caracteristicasPedido.VisualNumeroDoProduto &&
                          caracteristicasPedido.DescricaoVisualOutros)"
                        > 
                          <div class="label-conteudo"> {{ caracteristicasPedido.VisualAmostra == true ? 'Amostra' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.VisualArquivoDescricao ? `Visual Arquivo: ${caracteristicasPedido.VisualArquivoDescricao}` : ''}} </div>
                          <div class="label-conteudo"> {{caracteristicasPedido.VisualNumeroDoProduto ? `Produto: ${caracteristicasPedido.VisualNumeroDoProduto}` : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.DescricaoVisualOutros ? `Outros: ${caracteristicasPedido.DescricaoVisualOutros}` : ''}} </div>                  
                        </div>

                        <div class="label-conteudo" v-else> Sem dados </div>
                      </div>

                      <div class="faca-sistema">
                        <div class="titulo-conteudo-detalhes"> Faca Sistema </div>

                        <div v-if="!(caracteristicasPedido.FacaSistemaAmostra &&
                          caracteristicasPedido.FacaSistemaRiscoDeFaca &&
                          caracteristicasPedido.FacaSistemaPlanta &&
                          caracteristicasPedido.FacaSistemaPrototipoDescricao &&
                          caracteristicasPedido.CodigoFacaSistemaProduto &&
                          caracteristicasPedido.FacaSistemaOutros)"
                        >   
                          <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaAmostra == true ? 'Amostra' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPlanta == true ? 'Planta' : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaSistemaPrototipoDescricao}` : ''}} </div>
                          <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaSistemaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaSistemaProduto}` : ''}} </div>
                          <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaOutros ? `Outros: ${caracteristicasPedido.FacaSistemaOutros}` : ''}} </div>                     
                        </div>

                        <div class="label-conteudo" v-else> Sem dados </div>
                      </div>

                      <div class="faca-medida">
                        <div class="titulo-conteudo-detalhes"> Faca Medida </div>

                        <div v-if="!(caracteristicasPedido.FacaMedidaAmostra &&
                            caracteristicasPedido.FacaMedidaRiscoDeFaca &&
                            caracteristicasPedido.FacaMedidaPlanta &&
                            caracteristicasPedido.FacaMedidaPrototipoDescricao &&
                            caracteristicasPedido.CodigoFacaMedidaProduto &&
                            caracteristicasPedido.FacaMedidaOutros)"
                          >
                            <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaAmostra == true ? 'Amostra' : ''}} </div>
                            <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
                            <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPlanta == true ? 'Planta' : ''}} </div>
                            <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaMedidaPrototipoDescricao}` : ''}} </div>
                            <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaMedidaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaMedidaProduto}` : ''}} </div>
                            <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaOutros ? `Outros: ${caracteristicasPedido.FacaMedidaOutros}` : ''}} </div>                            
                          </div>

                        <div class="label-conteudo" v-else> Sem dados </div>
                      </div>
                    </div>
                  </div>                
                </div>
              </div>
            </div> 
          </div>

          <div class="html2pdf__page-break"/>

          <div class="content-grupo informacoes-produto">
            <div class="template-pagina">
              <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                <div class="titulo-conteudo-detalhes label-codigo-externo">#{{detalhesDoPedidoFluxo.CodigoExternoPedido}}</div>
                <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
              </div>
              
              <div class="imagem-template-rodape espaco-data-rodape">
                <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
              </div>
            </div>

            <div class="content-info-produto grupo">
              <div class="container">
                <div class="grupo-produto conteudo-grupo">
                  <div class="info-produto">
                    <div class="borda-titulo-grupo titulo-dados-pedido">
                      <div class="titulo-grupo"> PRODUTO </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-info-produto">
                      <div class="produto">
                        <div class="titulo-conteudo-detalhes"> Produto </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.NomeProduto}}</div>
                      </div>

                      <div class="data-ultimo-faturamento">
                        <div class="titulo-conteudo-detalhes"> Data do Último Faturamento </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.DataUltimoFaturamentoFormatada}}</div>
                      </div>

                      <div class="data-ultima-venda">
                        <div class="titulo-conteudo-detalhes"> Data da Última Venda </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.DataUltimaVendaFormatada}}</div>
                      </div>

                      <div class="porcentagem-ipi">
                        <div class="titulo-conteudo-detalhes"> Porcentagem do IPI </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.Ipi || '0'}}%</div>
                      </div>

                      <div class="produto-linha">
                        <div class="titulo-conteudo-detalhes"> Produto está em linha? </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.EmLinha == true ? 'Sim' : 'Não'}}</div>
                      </div>

                      <div class="produto-selo-fsc">
                        <div class="titulo-conteudo-detalhes"> Produto possui selo FSC? </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.Fsc == true ? 'Sim' : 'Não'}}</div>
                      </div>
                    </div>
                  </div>

                  <div class="observacoes-produto">
                    <div class="borda-titulo-grupo titulo-obs-produto">
                      <div class="titulo-grupo"> OBSERVAÇÕES </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="conteudo-obs-produto">
                      <div class="observacoes-produto">
                        <div class="titulo-conteudo-detalhes"> Observações da Impressão, Visual, Faca Sistema e Faca Medida </div>
                        <div class="label-conteudo">{{novoPedidoDetalhes.ObservacaoGeral || 'Sem Informações.'}}</div>
                      </div>

                      <div class="quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo"
                        >
                          Obs: De acordo com as Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou a menos.  
                        </div>
                      </div>

                      <div class="critica-processo">
                        <div class="titulo-conteudo-detalhes"> Crítica ao processo </div>
                        <div class="checkbox-filtros">
                          <div class="input-checkbox critica-container">
                            <label class="label-checkbox" for="fechamento-maquina">
                              O produto terá fechamento por máquina por parte do cliente?
                            </label>
                            <label :class="`label-checkbox critica-bool ${novoPedidoDetalhes.Critica3 ? 'botao-positivo' : 'botao-negativo'}`" for="fechamento-maquina">
                              {{ novoPedidoDetalhes.Critica3 ? "SIM" : "NÃO" }}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>   
                  
                  <div class="container-principal-componentes">
                    <div class="borda-titulo-grupo titulo-componentes">
                      <div class="titulo-grupo"> COMPONENTES </div>
                      <div class="borda-grupo"></div>
                    </div>

                    <div class="container-componentes" v-if="ComponentePedidoArray.length > 0">
                      <div v-for="(data, indexComp) in ComponentePedidoArray" :key="indexComp">
                        <div :class="`box-componentes-t1 ${indexComp % 2 == 0 ? 'box-componente-espacamento-t1' : ''}`" v-if="(indexComp + 1) <= 2">
                          <div class="imagem-numero-nome-componente">
                            <div class="imagem-grupo-componente">
                              <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                            </div>
                            
                            <div class="numero-nome-componente">
                              <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ indexComp + 1 }}</div>
                              <div class="nome-componente label-conteudo">{{data.componenteTipoTexto}}</div>
                            </div>
                          </div> 

                          <div class="grupo-componentes">
                            <div class="componentes-medidas">
                              <div class="titulo-conteudo-detalhes"> Medidas </div>
                              <div class="label-conteudo">{{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.ColunaMedidas : data.descricaoMedidasTexto }}</div>
                            </div>

                            <div class="componentes-cor-frente">
                              <div class="titulo-conteudo-detalhes"> Cor Frente </div>
                              <div class="label-conteudo">{{data.descricaoCoresFrenteTexto}}</div>
                            </div>

                            <div class="componentes-cor-verso">
                              <div class="titulo-conteudo-detalhes"> Cor Verso </div>
                              <div class="label-conteudo">{{data.descricaoCoresVersoTexto}}</div>
                            </div>

                            <div class="componentes-acabFrente">
                              <div class="titulo-conteudo-detalhes"> Acabamento Frente </div>
                              <div class="label-conteudo">{{data.descricaoAcabamentoFrenteTexto}}</div>
                            </div>

                            <div class="componentes-acabVerso">
                              <div class="titulo-conteudo-detalhes"> Acabamento Verso </div>
                              <div class="label-conteudo">{{data.descricaoAcabamentoVersoTexto}}</div>
                            </div>

                            <div class="componentes-material">
                              <div class="titulo-conteudo-detalhes"> Material </div>
                              <div class="label-conteudo">{{data.descricaoMaterialTexto}}</div>
                            </div>

                            <div class="componentes-onda">
                              <div class="titulo-conteudo-detalhes"> Onda </div>
                              <div class="label-conteudo">{{data.descricaoOndaTexto}}</div>
                            </div>

                            <div class="componentes-capaExt">
                              <div class="titulo-conteudo-detalhes"> Capa Externa </div>
                              <div class="label-conteudo">{{data.descricaoCapaExternaTexto}}</div>
                            </div>

                            <div class="componentes-capaInt">
                              <div class="titulo-conteudo-detalhes"> Capa Interna </div>
                              <div class="label-conteudo">{{data.descricaoCapaInternaTexto}}</div>
                            </div>

                            <div class="componentes-papelOnda">
                              <div class="titulo-conteudo-detalhes"> Papel de Onda </div>
                              <div class="label-conteudo">{{data.descricaoPapelOndaTexto}}</div>
                            </div>

                            <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                              <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                              <div class="label-conteudo">{{ data.sistema }}</div>
                            </div>

                            <div class="componentes-embalagem-coletiva"
                              v-if="  data.embalagemPalete == true || 
                              data.embalagemFilmeEncolhivel == true || 
                              data.embalagemCaixaColetiva == true || 
                              data.embalagemPapelEmbrulho == true || 
                              data.quantidadeOutros != 0"
                            >
                              <div class="titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                              <div class="labels-embalagem-coletiva">
                                <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                                >{{ texto }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="label-conteudo label-sem-componentes" v-else> Não possui componentes. </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="html2pdf__page-break" v-if="ComponentePedidoArray.length > 2"/>

          <div class="content-grupo informacoes-componentes" v-if="ComponentePedidoArray.length > 2">
            <div class="container-base"> 
              <div class="contador-pag-componentes" v-for="e in Math.ceil(ComponentePedidoArray.length / 4)" :key="e">
                <div class="template-pagina-comp">
                  <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class="titulo-conteudo-detalhes label-codigo-externo">#{{detalhesDoPedidoFluxo.CodigoExternoPedido}}</div>
                    <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
                  </div>
                  
                  <div class="imagem-template-rodape espaco-data-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                  </div>
                </div>

                <div class="template-pagina-comp" v-if="!ComponentePedidoArray.length > 0">
                  <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                    <div class="titulo-conteudo-detalhes label-codigo-externo">#{{detalhesDoPedidoFluxo.CodigoExternoPedido}}</div>
                    <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
                  </div>
                  
                  <div class="imagem-template-rodape espaco-data-rodape">
                    <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div>
                    <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                  </div>
                </div>
              </div>
            </div>

            <div class="container-principal-componentes grupo">
              <div class="container-componentes container-componentes-t2">
                <div v-for="(data, indexComp) in ComponentePedidoArray.slice(2)" :key="indexComp">
                  <div :class="`box-componentes-t2 ${indexComp % 2 === 0 ? 'box-componente-espacamento-t2' : ''} ${(indexComp + 1) % 5 === 0 ? 'box-componente-espacamento-topo' : ''}`">
                    <div class="imagem-numero-nome-componente">
                      <div class="imagem-grupo-componente">
                        <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                      </div>
                      
                      <div class="numero-nome-componente">
                        <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ indexComp + 3 }}</div>
                        <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                      </div>
                    </div> 

                    <div class="grupo-componentes">
                      <div class="componentes-medidas">
                        <div class="titulo-conteudo-detalhes"> Medidas </div>
                        <div class="label-conteudo">{{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? data.ColunaMedidas : data.descricaoMedidasTexto }}</div>
                      </div>

                      <div class="componentes-cor-frente">
                        <div class="titulo-conteudo-detalhes"> Cor Frente </div>
                        <div class="label-conteudo">{{data.descricaoCoresFrenteTexto}}</div>
                      </div>

                      <div class="componentes-cor-verso">
                        <div class="titulo-conteudo-detalhes"> Cor Verso </div>
                        <div class="label-conteudo">{{data.descricaoCoresVersoTexto}}</div>
                      </div>

                      <div class="componentes-acabFrente">
                        <div class="titulo-conteudo-detalhes"> Acabamento Frente </div>
                        <div class="label-conteudo">{{data.descricaoAcabamentoFrenteTexto}}</div>
                      </div>

                      <div class="componentes-acabVerso">
                        <div class="titulo-conteudo-detalhes"> Acabamento Verso </div>
                        <div class="label-conteudo">{{data.descricaoAcabamentoVersoTexto}}</div>
                      </div>

                      <div class="componentes-material">
                        <div class="titulo-conteudo-detalhes"> Material </div>
                        <div class="label-conteudo">{{data.descricaoMaterialTexto}}</div>
                      </div>

                      <div class="componentes-onda">
                        <div class="titulo-conteudo-detalhes"> Onda </div>
                        <div class="label-conteudo">{{data.descricaoOndaTexto}}</div>
                      </div>

                      <div class="componentes-capaExt">
                        <div class="titulo-conteudo-detalhes"> Capa Externa </div>
                        <div class="label-conteudo">{{data.descricaoCapaExternaTexto}}</div>
                      </div>

                      <div class="componentes-capaInt">
                        <div class="titulo-conteudo-detalhes"> Capa Interna </div>
                        <div class="label-conteudo">{{data.descricaoCapaInternaTexto}}</div>
                      </div>

                      <div class="componentes-papelOnda">
                        <div class="titulo-conteudo-detalhes"> Papel de Onda </div>
                        <div class="label-conteudo">{{data.descricaoPapelOndaTexto}}</div>
                      </div>

                      <div class="componentes-descricao" v-if="data.descricaoSistema == 0">
                        <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                        <div class="label-conteudo">{{ data.sistema }}</div>
                      </div>

                      <div class="componentes-embalagem-coletiva"
                        v-if="  data.embalagemPalete == true || 
                        data.embalagemFilmeEncolhivel == true || 
                        data.embalagemCaixaColetiva == true || 
                        data.embalagemPapelEmbrulho == true || 
                        data.quantidadeOutros != 0"
                      >
                        <div class="titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                        <div class="labels-embalagem-coletiva">
                          <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                          >{{ texto }}</div>
                        </div>
                      </div>
                    </div>

                    <div class="html2pdf__page-break" v-if="(indexComp + 1) % 4 === 0 && (indexComp + 1) != ComponentePedidoArray.length"/>
                  </div>
                </div>
              </div>

              <div class="label-conteudo label-sem-componentes"> Não possui componentes. </div>
            </div>
          </div>

          <div class="html2pdf__page-break"/>

          <div class="content-grupo informacoes-parcelas">
            <div class="contador-paginas" v-for="e in Math.ceil(this.parcelasInfo.length / 2)" :key="e">
              <div class="template-pagina">
                <div class="imagem-template-cabecalho espaco-codigo-externo-cabecalho">
                  <div class="titulo-conteudo-detalhes label-codigo-externo">#{{detalhesDoPedidoFluxo.CodigoExternoPedido}}</div>
                  <img src="@/assets/imgs/Cabecalho_PDF_Pedido.svg" class="img-cabecalho">
                </div>
                
                <div class="imagem-template-rodape espaco-data-rodape">
                  <div class="data-carta-proposta titulo-conteudo-detalhes data-rodape"> Jaú, {{ this.DiaHoje }} </div> 
                  <img src="@/assets/imgs/Rodape_CartaProposta.svg" class="img-rodape">
                </div>
              </div>
            </div>

            <div class="content-info-parcelas grupo">
              <div class="container-parcelas">
                <div class="borda-titulo-grupo titulo-parcelas">
                  <div class="titulo-grupo"> PARCELA(S) </div>
                  <div class="borda-grupo"></div>
                </div>

                <div class="grupo-parcelas">
                  <div class="parcelas" v-for="(obj, index) in this.parcelasInfo" :key="index">
                    <div class="numero-parcela"> {{index + 1}}º Parcela </div>

                    <div class="conteudo-parcelas">
                      <div class="data-carregamento">
                        <div class="titulo-conteudo-detalhes"> Data Carregamento </div>
                        <div class="label-conteudo">{{obj.dataCarregamentoFormatada || 'Sem Dados'}}</div>
                      </div>

                      <div class="quantidade">
                        <div class="titulo-conteudo-detalhes"> Quantidade </div>
                        <div class="label-conteudo">{{formataDecimal(obj.quantidadePedidoParcela)}}</div>
                      </div>

                      <div class="data-conf-carregamento">
                        <div class="titulo-conteudo-detalhes"> Data Conf. Carregamento </div>
                        <div class="label-conteudo">{{obj.dataPedidoParcelaFormatada}}</div>
                      </div>

                      <div class="qtde-produzida">
                        <div class="titulo-conteudo-detalhes"> Quantidade Produzida </div>
                        <div class="label-conteudo">{{formataDecimal(obj.quantidadeProduzida)}}</div>
                      </div>

                      <div class="qtde-expedida">
                        <div class="titulo-conteudo-detalhes"> Quantidade Expedida </div>
                        <div class="label-conteudo">{{formataDecimal(obj.quantidadeExpandida)}}</div>
                      </div>

                      <div class="parcela">
                        <div class="titulo-conteudo-detalhes"> Parcela </div>
                        <div class="label-conteudo">{{obj.numeroParcela}}</div>
                      </div>

                      <div class="agua-liberacao-producao">
                        <div class="titulo-conteudo-detalhes"> Aguardando Liberação para Produzir </div>
                        <div class="label-conteudo">{{obj.liberadoParaProduzir == false ? 'Não' : 'Sim' }}</div>
                      </div>

                      <div class="dias-prorrogados">
                        <div class="titulo-conteudo-detalhes"> Dias Prorrogados </div>
                        <div class="label-conteudo">{{obj.numeroParcelaDias}}</div>
                      </div>

                      <div class="indicador">
                        <div class="titulo-conteudo-detalhes"> Indicador </div>
                        <div class="label-conteudo">{{obj.indicadorTexto || '-'}}</div>
                      </div>

                      <div class="data-base">
                        <div class="titulo-conteudo-detalhes"> Data Base </div>
                        <div class="label-conteudo">{{obj.dataBasePedidoParcelaFormatada || '-'}}</div>
                      </div>

                      <div class="ordem-compra">
                        <div class="titulo-conteudo-detalhes"> Ordem de Compra </div>
                        <div class="label-conteudo">{{obj.numeroOrdemDeCompra || 'Não Possui'}}</div>
                      </div>

                      <div class="componente">
                        <div class="titulo-conteudo-detalhes"> Componente </div>
                        <div class="label-conteudo" v-for="(componente, index) in obj.componentePedidoParcelaArray" :key="index"
                        >
                          {{componente.componenteTipoTexto || 'Não Possui'}}
                        </div>
                      </div>

                      <div class="fase-producao">
                        <div class="titulo-conteudo-detalhes"> Fase de Produção </div>
                        <div class="label-conteudo" v-for="(componente, index) in obj.componentePedidoParcelaArray" :key="index"
                        >
                          {{componente.descricaoFaseProduto || 'Não Possui'}}
                        </div>
                      </div>

                      <div class="obs-parcelas">
                        <div class="titulo-conteudo-detalhes"> Observações sobre as parcelas </div>
                        <div class="label-conteudo">{{obj.descricaoParcela || 'Não Possui'}}</div>
                      </div>
                    </div>

                    <div class="html2pdf__page-break" v-if="(index + 1) % 2 === 0 && (index + 1) != this.parcelasInfo.length"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="html2pdf__page-break" />
        </div>
      </div>
    </g-card> 
  </div>
</template>

<script>
import PedidoEmAndamentoPDF from './PedidoEmAndamentoPDF.js'
export default PedidoEmAndamentoPDF;
</script>

<style scoped>
.card-pdf-pedido-final {
  font-family: 'MontSerrat';
}

.content-grupo {
  position: relative;
  height: 100%;
}

.template-pagina {
  position: absolute;
  height: 70.125rem;
  width: 100%;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1000;
}

.imagem-template-cabecalho {
  display: flex;
  align-items: flex-start;
}
.imagem-template-rodape {
  position: relative;
  display: flex;
  align-items: flex-end;
}

.img-cabecalho, .img-rodape {
  width: 99.25%;
}

.espaco-codigo-externo-cabecalho {
  position: relative;
}

.label-codigo-externo {
  position: absolute;
  height: 100%;
  width: 99.25%;
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
  font-weight: 600 !important;
  letter-spacing: 0.08rem;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  padding: 0 0 0.2rem 7.2rem;
  z-index: 1000;
}

.espaco-data-rodape {
  position: relative;
}
.data-rodape {
  color: #fff !important;
  font-size: 0.75rem !important;
  font-weight: 500;
  position: absolute;
  height: 100%;
  width: 99.25%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  left: 0;
  padding: 0.35rem 1.5rem 0.3rem 0;
  z-index: 1000;
}

.grupo {
  position: absolute;
  padding: 5.5rem 2rem 0;
  width: 99.25%;
}

.borda-titulo-grupo {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0.8rem;
}

.borda-grupo {
  width: 5rem;
  height: 3px;
  background-color: #FCB315;
}

.titulo-grupo {
  width: 100%;
  color: #4f2c19;
  text-align: left;
  font-size: 1.1rem;
  font-family: "MontSerrat";
  font-weight: 700;
  padding-bottom: 0.3rem;
  letter-spacing: 1px;
}

.titulo-conteudo-detalhes {
  color: #3f3f3f;
  font-size: 0.8rem;
  margin-top: 0.1rem;
}
.label-conteudo {
  font-size: 0.8rem;
}

.unidade-representante {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.conteudo-grupo {
  width: 99.25%;
  display: flex;
  flex-direction: column;
  row-gap: 3.5rem;
}

.grupo-produto {
  row-gap: 2.5rem !important;
}

.conteudo, 
.conteudo-caracts-pedido, 
.conteudo-info-produto {
  padding: 1rem;
}
.conteudo-parcelas {
  padding: 1rem 1.5rem 0.3rem;
}

.dados-pedido, 
.conteudo-caracts-pedido, 
.conteudo-info-produto,
.conteudo-parcelas {
  border-radius: 0.5rem;
}

.dados-pedido, 
.conteudo-info-produto, 
.conteudo-parcelas {
  background-color: #F9F9F9;
}

.conteudo-caracts-pedido {
  background-color: #E3E3E3;
}

.conteudo-detalhes-pedido,
.conteudo-dados-pedido,
.conteudo-caracts-pedido {
  display: grid;
  grid-template-columns: repeat(3, 1fr) max-content;
  gap: 0.5rem 1rem;
}

.conteudo-info-produto, .conteudo-parcelas {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.5rem 1rem;
}

.conteudo-obs-produto {
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
}

.container-base {
  position: absolute;
  width: 100%;
}

.contador-pag-componentes {
  position: relative;
  z-index: 2000;
  left: 0;
}

.template-pagina-comp {
  height: 70.125rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.container-principal-componentes {
  position: relative;
  z-index: 1;
}

.container-componentes {
  height: auto;
  width: 99.25%;
  display: flex;
  flex-wrap: wrap;
  /* column-gap: 1.2rem; */
  row-gap: 2rem;
  margin-top: 1rem;
}

.container-componentes-t2 {
  margin-top: 4rem;
}

.box-componentes-t1 {
  min-height: 25rem;
  width: 22rem; 
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  align-items: space-between;
  row-gap: 0.5rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente-espacamento-t1 {
  margin-right: 0.75rem;
}

.box-componentes-t2 {
  min-height: 25rem;
  width: 22rem; 
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente-espacamento-t2 {
  margin-right: 1.2rem;
}

.box-componente-espacamento-topo {
  margin-top: 6rem
}

.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.img-componente {
  height: 2.5rem;
  width: auto;
}

.numero-nome-componente {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 0.4rem;
}

.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19;
}

.grupo-componentes {
  display: grid;
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
  grid-auto-rows: auto;
  gap: 0.5rem 0.2rem;
}
.grupo-componentes .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.grupo-componentes .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.grupo-componentes .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.grupo-componentes .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.grupo-componentes .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.grupo-componentes .componentes-material { grid-area: 4 / 1 / 5 / 2; }
.grupo-componentes .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.grupo-componentes .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.grupo-componentes .componentes-capaInt { grid-area: 5 / 2 / 6 / 3; }
.grupo-componentes .componentes-papelOnda { grid-area: 6 / 1 / 7 / 2; }
.grupo-componentes .componentes-embalagem-coletiva { grid-column: 1 / 3; }

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
}

.checkbox-filtros {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.critica-container {
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.critica-bool {
  color: #F9F9F9;
  width: max-content;
  padding: 0.2rem 1rem;
  border-radius: 0.2rem;
}

.label-checkbox {
  font-size: 0.8rem;
  margin-left: 0;
}

.botao-positivo {
  background-color: #3dca55;
}
.botao-negativo {
  background-color: #DC4242;
}

.grupo-parcelas {
  margin-top: 3rem;
}

.numero-parcela {
  color: #4D4D4D;
  margin: 1.5rem 0 1rem;
}

.conteudo-parcelas {
  margin-bottom: 3rem;
}

.obs-parcelas {
  grid-column: span 2;
}
</style>